import createHistory from 'history/createBrowserHistory';

export default createHistory();



// WEBPACK FOOTER //
// ./app/utils/routeHistory.js